import BasicBadge, {InfoType} from "../../../components/BasicBadge";
import React from "react";
import {DettaglioRetribuzioneRecord} from "@commons/mapping/DettaglioRetribuzioneRecord";

const stats = [
    {name: 'Elementi contrattuali nazionali', descrizione: 'Elementi retributivi fissati dal contratto applicato a livello nazionale.', style: DettaglioRetribuzioneRecord.getType(1)},
    {
        name: 'Elementi ad-pesonam',
        descrizione: 'Elementi contrattuali o concordati con il lavoratore sulla base di specifici accordi o mansioni.',
        style: DettaglioRetribuzioneRecord.getType(7)
    },
    {name: 'Elementi contrattuali territoriali', descrizione: 'Elementi retributivi fissati a livello regionale o territoriale.', style: DettaglioRetribuzioneRecord.getType(15)},
]

export const LegendaRML: React.FC<{ discrezionale?: boolean }> = ({discrezionale = false}) => {
    return (
        <div>
            <h3 className="mt-3 text-xs font-normal leading-6 text-gray-900">Legenda</h3>
            <dl className={`grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow ${discrezionale ? 'md:grid-cols-4' : 'md:grid-cols-3'} md:divide-y-0 md:divide-x`}>
                {stats.map((item) => (
                    <div key={item.name} className="px-4 py-5 sm:p-2">
                        <dt className="font-medium text-gray-900">
                            <BasicBadge type={item.style as InfoType} containerClass={'text-sm'} label={item.name}/></dt>
                        <dd className="mt-1 flex items-baseline justify-between md:block lg:flex">
                            <div className="flex items-baseline text-xs text-blue-600">
                                {item.descrizione}
                            </div>
                        </dd>
                    </div>
                ))}
                {discrezionale && <div className="px-4 py-5 sm:p-2">
                    <dt className="font-medium text-gray-900">
                        <span className="border border-red-600 p-1 text-sm">Elemento discrezionale</span></dt>
                    <dd className="mt-1 flex items-baseline justify-between md:block lg:flex">
                        <div className="flex items-baseline text-xs text-blue-600">
                            Elemento ad personam (determinato dalla mansione, dalle policies aziendali e/o dagli accordi intercorsi tra l'azienda e ciascun lavoratore).
                        </div>
                    </dd>
                </div>}
            </dl>
        </div>
    )
}
export default LegendaRML;